import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const clientApi = axios.create({ baseURL: API });

clientApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('dts_client_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default clientApi;
